import { cardRank, cardSuit, nextSeat, partnerOf } from './types.js';
/**
 * The suit that trumps, or null at notrump. Exported for packages/ai's
 * claim search (claim.ts), which walks positions card by card without
 * building a PlayState and would otherwise need its own copy of this
 * mapping — one place for strain↔suit, so the two can never disagree.
 */
export function trumpSuit(strain) {
    // strain 0=♣ 1=♦ 2=♥ 3=♠ 4=NT; our suits 0=♠ 1=♥ 2=♦ 3=♣
    return strain === 4 ? null : 3 - strain;
}
export function trickWinner(trick, strain) {
    const trump = trumpSuit(strain);
    const ledSuit = cardSuit(trick[0].card);
    let best = trick[0];
    for (const play of trick.slice(1)) {
        const suit = cardSuit(play.card);
        const bestSuit = cardSuit(best.card);
        if (trump !== null && suit === trump && bestSuit !== trump) {
            best = play;
        }
        else if (suit === bestSuit && cardRank(play.card) > cardRank(best.card)) {
            best = play;
        }
    }
    return best.seat;
}
export function playState(deal, contract, plays) {
    const dummy = partnerOf(contract.declarer);
    const opening = nextSeat(contract.declarer);
    const completedTricks = [];
    let currentTrick = [];
    let leader = opening;
    let declarerTricks = 0;
    let defenderTricks = 0;
    for (const card of plays) {
        const seat = currentTrick.length === 0 ? leader : ((currentTrick[currentTrick.length - 1].seat + 1) % 4);
        currentTrick.push({ seat, card });
        if (currentTrick.length === 4) {
            const winner = trickWinner(currentTrick, contract.strain);
            completedTricks.push(currentTrick);
            currentTrick = [];
            leader = winner;
            if (winner % 2 === contract.declarer % 2)
                declarerTricks++;
            else
                defenderTricks++;
        }
    }
    const handToPlay = currentTrick.length === 0 ? leader : ((currentTrick[currentTrick.length - 1].seat + 1) % 4);
    const isOver = completedTricks.length === 13;
    return {
        contract,
        plays,
        turn: handToPlay === dummy ? contract.declarer : handToPlay,
        handToPlay,
        currentTrick,
        completedTricks,
        declarerTricks,
        defenderTricks,
        isOver,
        dummy,
        dummyVisible: plays.length >= 1,
    };
}
/** Cards remaining in a hand given the play history. */
export function remainingCards(deal, plays, seat) {
    const played = new Set(plays);
    return deal.hands[seat].filter((c) => !played.has(c));
}
/** Legal cards for the hand currently required to play. */
export function legalCards(deal, state) {
    if (state.isOver)
        return [];
    const hand = remainingCards(deal, state.plays, state.handToPlay);
    if (state.currentTrick.length === 0)
        return hand;
    const ledSuit = cardSuit(state.currentTrick[0].card);
    const follow = hand.filter((c) => cardSuit(c) === ledSuit);
    return follow.length > 0 ? follow : hand;
}
export function applyPlay(deal, state, card) {
    if (!legalCards(deal, state).includes(card)) {
        throw new Error(`illegal card ${card}`);
    }
    return [...state.plays, card];
}
//# sourceMappingURL=play.js.map